/* This file is generated by scripts/generateTypes.ts */
import { z } from "zod";

import { Hue } from "theme/constants";

export const Route = {
  HOME: "HOME",
  RESUME: "RESUME",
} as const;
export const RouteSchema = z.nativeEnum(Route);
export type Route = z.infer<typeof RouteSchema>;

export const RoutePath = {
  HOME: "/",
  RESUME: "/resume",
} as const;
export const RoutePathSchema = z.nativeEnum(RoutePath);
export type RoutePath = z.infer<typeof RoutePathSchema>;

export const RouteLastModified = {
  HOME: "1705283790000",
  RESUME: "1692476792000",
} as const;
export const RouteLastModifiedSchema = z.nativeEnum(RouteLastModified);
export type RouteLastModified = z.infer<typeof RouteLastModifiedSchema>;

export type FullRoute = `/${Hue}${RoutePath}`;
